module.exports = __webpack_public_path__ + "img/social-app.675e88dd.jpg";